import styled, { css } from 'styled-components';
import { Flex } from '@/ui/Flex/Flex';
import { Button } from '@/ui/Button/Button';
import { Card } from '@/ui/Card/Card';

export const StyledWrapper = styled(Flex)<{ readonly hidden: boolean }>`
  width: 100%;

  ${({ hidden }) =>
    hidden &&
    css`
      height: 100vh;
      overflow: hidden;
      visibility: hidden;
      pointer-events: none;
    `}
`;

export const StyledBackButton = styled(Button)`
  width: 32px;
  height: 32px;
`;

export const StyledCodeEditorButton = styled(Button)``;

export const StyledRestartButton = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.color('#B2B1BA')};
      pointer-events: none;
    `}
`;

export const StyledSensorLibrary = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.color('#B2B1BA')};
      pointer-events: none;
    `}
`;

export const StyledSettings = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.color('#B2B1BA')};
      pointer-events: none;
    `}
`;

export const StyledChangesBtn = styled(Button)<{ disabled: Boolean }>`
  width: 32px;
  height: 32px;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      pointer-events: none;
    `}
`;

export const StyledSaveButton = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.color('#B2B1BA')};
      pointer-events: none;
    `}
`;

export const StyledCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 36px;
  background-color: ${({ theme }) => theme.color('#F6F6F6')};
  border-radius: 17px;
`;

export const StyledLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;

  svg {
    width: 48px;
    height: 48px;
    stroke: ${({ theme }) => theme.color('#676570')};
  }
`;

export const StyledEmptySlideGroup = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  min-width: 260px;
  margin: -4px 0;
`;

export const StyledEditorWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  overflow: hidden;
`;

export const StyledCard = styled(Card)`
  margin: 16px;
  display: flex;
  flex-direction: row;
  min-height: 284px;
  cursor: pointer;
`;

export const StyledIconWrapper = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.color('#B2B1BA')};
  padding: 10px;
  border-radius: 50%;

  &:hover {
    background-color: ${({ theme }) => theme.color('#F6F6F6')};
  }
`;

export const StyledMinIconWrapper = styled.span`
  display: grid;
  width: 16px;
  & > svg {
    max-width: 16px;
    max-height: 16px;
  }
`;
